module.exports = __webpack_public_path__ + "img/anli3.fc9a7990.jpg";